import { useTranslation } from 'react-i18next';

const Rule = ({ isValid, isTouched, children }) => {
  const color = isTouched
    ? isValid
      ? 'text-green-600'
      : 'text-red-500'
    : 'text-k-p';
  return (
    <div className={`flex items-center gap-2 text-sm ${color}`}>
      <i
        className={`fa-regular ${isValid ? 'fa-circle-check' : 'fa-circle'}`}
        style={{ fontSize: 16 }}
      />
      {children}
    </div>
  );
};

export const isLongerThanEight = (input) => input.match(/.{8,}/);
export const hasOneDigit = (input) => input.match(/[0-9]/g);
export const hasOneUppercase = (input) => input.match(/[A-Z]/g);

export const validatePassword = ({ password, error }) => {
  if (
    !isLongerThanEight(password) ||
    !hasOneDigit(password) ||
    !hasOneUppercase(password)
  ) {
    return { password: error };
  }
  return null;
};

const PasswordStrength = ({ password, isTouched }) => {
  const { t } = useTranslation(['auth', 'errors']);

  return (
    <div className="mt-2 space-y-1">
      <Rule isValid={isLongerThanEight(password)} isTouched={isTouched}>
        {t('passwordValidation.characters')}
      </Rule>
      <Rule isValid={hasOneUppercase(password)} isTouched={isTouched}>
        {t('passwordValidation.capital')}
      </Rule>
      <Rule isValid={hasOneDigit(password)} isTouched={isTouched}>
        {t('passwordValidation.number')}
      </Rule>
    </div>
  );
};

export default PasswordStrength;
